"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionId = void 0;
var PermissionId;
(function (PermissionId) {
    PermissionId["seeForecast"] = "1100";
    PermissionId["editForecast"] = "1200";
    PermissionId["seeRevenue"] = "2100";
    PermissionId["configureAdmins"] = "3200";
    PermissionId["configureUsers"] = "3210";
    PermissionId["seeAllMarketLocations"] = "4100";
})(PermissionId || (exports.PermissionId = PermissionId = {}));
